import { ComposerBanner } from './ComposerBanner';

export const LegacyChatWarning = () => {
  return (
    <ComposerBanner className="bg-[color-mix(in_srgb,var(--amber-9)_8%,transparent)]">
      <p className="text-sm text-foreground font-medium">
        Littlebird now has a new and improved agent. This chat was started with
        an older version and may have some quirks. Feel free to wrap up here or
        start a new chat for the best experience.
      </p>
    </ComposerBanner>
  );
};
